<template>
    <div>
        <el-dialog
            title="调查问卷详情"
            :visible.sync="showpicker"
            width="800px"
            @close="back">
            <div class="warp">
                <p class="title">{{survey.title}}</p>
                <el-row>
                    <el-col :span="12">用户姓名：{{survey.name}}</el-col>
                    <el-col :span="12">用户手机：{{survey.telephone}}</el-col>
                </el-row>
                <div class="su-content">
                    <p class="text title">问卷调查内容:</p>
                    <div class="su-cell" v-for="(item, index) in survey.questions" :key="index">
                        <p class="text quest-title">{{index+1}}、{{item.quest}}</p>
                        <p class="text quest-value" v-if="!item.input">答案：{{item.value}}</p>
                        <p class="text quest-text" v-else>{{item.text}}</p>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showpicker: true,
            id: '',
            survey: '',
        }
    },
    mounted () {
        var id = this.$route.query.id;
        this.id = id;
        if (this.id) {
            this.getdata();
        }
    },
    methods: {
        getdata() {
            var params = {
                id: this.id,
            }
            this.$api.getsurveyvsid(params).then(
                data=>{
                    data.questions = data.questions?JSON.parse(data.questions):[];
                    this.survey = data;
                }
            )
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>
.title{
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: bold;
    text-align: center;
}
.su-content{
    margin-top: 20px;
    .text.title{
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        text-align: left;
        color:#555;
    }
    .su-cell{
        margin-bottom: 20px;
        .quest-value{
            text-indent: 1.4rem;
            color: #4773a0;
        }
        .quest-text{
            text-indent: 1.4rem;
            color: #3a8ee6;
            text-decoration: underline;
        }
    }
}
</style>